// React
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import App from './App'
import './index.css'

// Redux
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import reducers from './reducers'
import { loadFacebook, getFacebookLoginStatus } from './actions/facebook'
import registerReactives from './reactives'

// Stripe
import { loadStripe } from "@stripe/stripe-js"
import { Elements } from "@stripe/react-stripe-js"
import { stripePublishableTestKey, stripePublishableLiveKey } from './constants/keys'
import runningLocal from './util/local'

// Other stuff
import querystring from 'querystring'

// Initialize the Amazon Cognito credentials provider
const AWS = window.AWS
AWS.config.region = 'eu-central-1'

// insert dev-tools
const composeEnhancers =
  typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    })
    : compose

const enhancer = composeEnhancers(
  applyMiddleware(thunkMiddleware)
)

// Initialize Redux
let store = createStore(
  reducers,
  enhancer
)

// check for automatic stage registration
const qs = querystring.parse((window.location.search || '').replace('?', ''))
if (qs.registerStageId) {
  console.log('Found command to register for stage ' + qs.registerStageId)
  window.localStorage.setItem('registerStageId', qs.registerStageId)
}
if (qs.inviteId) {
  console.log('Found command to handle invite ' + qs.inviteId)
  window.localStorage.setItem('inviteId', qs.inviteId)
}

// Initialize Stripe
const stripeKey = runningLocal ? stripePublishableTestKey : stripePublishableLiveKey
const stripePromise = loadStripe(stripeKey)

// Render the app
ReactDOM.render(
    <Provider store={store}>
      <Router>
        <Elements stripe={stripePromise}>
          <App />
        </Elements>
      </Router>
    </Provider>
  , document.getElementById('root'))

registerReactives(store)

// load facebook and check authentication state
store.dispatch((dispatch) =>
  loadFacebook()(dispatch).then(() =>
    getFacebookLoginStatus()(dispatch)))
